import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNotification = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.232 2.184a2.19 2.19 0 0 1 2.296.776 5.55 5.55 0 0 1 4.752 4.078l.684 2.55c.14.525.455 1.002.883 1.337a2.273 2.273 0 0 1-.815 3.98l-3.562.954a2.1 2.1 0 0 1-1.548 2.183 2.1 2.1 0 0 1-2.432-1.116l-.653.175a2.273 2.273 0 0 1-2.695-3.04 2.55 2.55 0 0 0 .096-1.598l-.684-2.55a5.55 5.55 0 0 1 2.077-5.909 2.195 2.195 0 0 1 1.601-1.82m.388 1.45a.7.7 0 0 0-.508.72l.034.454-.384.24a4.05 4.05 0 0 0-1.759 4.476l.684 2.55a4.05 4.05 0 0 1-.152 2.547l-.002-.001a.773.773 0 0 0 .915 1.032l8.195-2.196a.773.773 0 0 0 .277-1.351 4.06 4.06 0 0 1-1.405-2.128l-.684-2.55a4.05 4.05 0 0 0-3.76-2.997l-.454-.016-.196-.41a.696.696 0 0 0-.8-.37"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNotification;
